import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { getOrder } from 'actions/booking';

import CheckinRoute from './Checkin';
import CheckoutRoute from './Checkout';
import PrintRoute from './Print';
import RenewRoute from './Renew';
import PaymentRoute from './Payment';

export default store => ({
	path: 'booking',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'userBooking',
				),
			store,
			'USER_BOOKING',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				await store.dispatch(getOrder());
				updateRatio(0.8);
			},
			store,
			'ENTER_USER_BOOKING',
		),
	},
	childRoutes: [
		{
			path: ':id',
			indexRoute: {
				component: null,
				onEnter: ({ params: { lang } }, replace) => replace(`/${lang}/user/booking`),
			},
			onEnter: withAsyncEnterLoader(
				async (_, __, updateRatio) => {
					updateRatio(0.8);
				},
				store,
				'ENTER_BOOKING_BY_ID',
			),
			childRoutes: [
				CheckinRoute(store),
				CheckoutRoute(store),
				PrintRoute(store),
				RenewRoute(store),
				PaymentRoute(store),
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/User/Booking/index.js